import {
  DARK_ORANGE,
  MALACHITE,
  MEDIUM_PURPLE,
  PACIFIC_BLU,
} from "constants/colors";

export const dummyProject = {
  published: 0,
  owners: [{ name: "Mario Rossi" }, { name: "Alessandro Bianchi" }],
  phases: [
    {
      id: 1,
      title: "Offering",
      owner: { name: "Mario Rossi" },
      bricks: [
        {
          id: 1,
          avatarImageUrl:
            "https://teamgroove-dev-content.s3.amazonaws.com/users_avatar/bevilacqua.jpg",
          title: "Preparazione presentazione presal sd fsdf e",
          startDate: "2021-03-01T00:00:00",
          endDate: "2021-10-01T00:00:00",
          users: 4,
        },
        {
          id: 2,
          avatarImageUrl:
            "https://teamgroove-dev-content.s3.amazonaws.com/users_avatar/bevilacqua.jpg",
          title: "Preparazione presentazione presal sd fsdf e",
          startDate: "2021-03-01T00:00:00",
          endDate: "2021-10-01T00:00:00",
        },
        {
          id: 3,
          avatarImageUrl:
            "https://teamgroove-dev-content.s3.amazonaws.com/users_avatar/bevilacqua.jpg",
          title: "Preparazione presentazione presal sd fsdf e",
          startDate: "2021-03-01T00:00:00",
          endDate: "2021-10-01T00:00:00",
        },
        {
          id: 4,
          avatarImageUrl:
            "https://teamgroove-dev-content.s3.amazonaws.com/users_avatar/bevilacqua.jpg",
          title: "Preparazione presentazione presal sd fsdf e",
          startDate: "2021-03-01T00:00:00",
          endDate: "2021-10-01T00:00:00",
          users: 6,
        },
        {
          id: 5,
          avatarImageUrl:
            "https://teamgroove-dev-content.s3.amazonaws.com/users_avatar/bevilacqua.jpg",
          title: "Preparazione presentazione presal sd fsdf e",
          startDate: "2021-03-01T00:00:00",
          endDate: "2021-10-01T00:00:00",
        },
        {
          id: 6,
          avatarImageUrl:
            "https://teamgroove-dev-content.s3.amazonaws.com/users_avatar/bevilacqua.jpg",
          title: "Preparazione presentazione presal sd fsdf e",
          startDate: "2021-03-01T00:00:00",
          endDate: "2021-10-01T00:00:00",
        },
        {
          id: 7,
          avatarImageUrl:
            "https://teamgroove-dev-content.s3.amazonaws.com/users_avatar/bevilacqua.jpg",
          title: "Preparazione presentazione presal sd fsdf e",
          startDate: "2021-03-01T00:00:00",
          endDate: "2021-10-01T00:00:00",
        },
      ],
    },
    {
      id: 2,
      title: "Presale",
      owner: { name: "Alessandro Bianchi" },
      bricks: [],
    },
    {
      id: 3,
      title: "Design",
      owner: { name: "Mario Rossi" },
      bricks: [
        {
          id: 7,
          avatarImageUrl:
            "https://teamgroove-dev-content.s3.amazonaws.com/users_avatar/bevilacqua.jpg",
          title: "Preparazione presentazione presal sd fsdf e",
          startDate: "2021-03-01T00:00:00",
          endDate: "2021-10-01T00:00:00",
        },
      ],
    },
  ],
};

export const dummyAIModalData = {
  constants: [
    {
      fullLabel: "Compatibile skill",
      shortLabel: "Compatibile",
      color: MALACHITE,
    },
    {
      fullLabel: "Time saving su progetti",
      shortLabel: "Saving",
      color: DARK_ORANGE,
    },
    {
      fullLabel: "Time Available",
      shortLabel: "Available",
      color: MEDIUM_PURPLE,
    },
    {
      fullLabel: "High quality rate",
      shortLabel: "Quality",
      color: PACIFIC_BLU,
    },
  ],
  values: [
    [81, 56, 41, 67],
    [92, 45, 38, 73],
    [75, 63, 52, 58],
    [88, 42, 35, 79],
    [65, 71, 48, 84],
    [94, 39, 44, 66],
    [72, 58, 55, 61],
    [86, 47, 33, 76],
    [69, 64, 49, 82],
    [91, 41, 37, 74],
    [83, 54, 46, 68],
    [77, 62, 51, 59],
    [89, 43, 36, 78],
    [66, 70, 47, 85],
    [95, 38, 45, 65],
    [73, 57, 54, 62],
    [87, 46, 34, 77],
    [68, 65, 50, 81],
    [90, 40, 38, 75],
    [84, 53, 43, 69],
  ],
};
